import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";

// import { Formik, Form } from "formik";
// import * as Yup from "yup";
import { useEffect } from "react";
import swal from "sweetalert";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import dayjs, { Dayjs } from "dayjs";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";

import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SearchIcon from "@mui/icons-material/Search";
// import SortIcon from "@mui/icons-material/Sort";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import Pagination from "@mui/material/Pagination";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

// import avtarPic from "../../../assets/Images/avtarPic.png";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// const Validation_Schema = Yup.object().shape({
//   selectedGuard: Yup.string().required("Required"),

//   selectedSpot: Yup.string().required("Required"),
// });

function AddDutyPage() {
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [selected, setSelected] = React.useState(false);

  // For memu
  // const [anchorEl10, setAnchorEl10] = React.useState(null);
  // const open10 = Boolean(anchorEl10);

  // const handleClick10 = (event) => {
  //   setAnchorEl10(event.currentTarget);
  // };
  // const handleClose10 = () => {
  //   setAnchorEl10(null);
  // };
  // End

  // For memu
  const [anchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // End

  const [q, setQ] = React.useState("");

  const [guardsList, setGuardsList] = React.useState([]);
  const [selectedGuard, setSelectedGuard] = React.useState("");
  const [spotList, setSpotList] = React.useState([]);
  const [selectedSpot, setSelectedSpot] = React.useState("");
  const [roasterId, setRoasterId] = React.useState();
  const [startDate, setStartDate] = React.useState(moment(new Date()));
  const [endDate, setEndDate] = React.useState(moment().add(8, "hours"));
  const [isEditRoaster, setisEditRoaster] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [guardErrMsg, setGuardErrMsg] = React.useState("");
  const [spotErrMsg, setSpotErrMsg] = React.useState("");
  const [startDtErrMsg, setStartDtErrMsg] = React.useState("");
  const [endDtErrMsg, setEndDtErrMsg] = React.useState("");

  const [showLoader, setShowLoader] = React.useState(false);

  const [dailyRoasterList, setDailyRoasterList] = React.useState([]);

  const [defaultProfilePic] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  const [tabName, setTabName] = React.useState("Today");
  const [spotId, setSpotId] = React.useState();
  const [spotName, setSpotName] = React.useState("");
  const [selectedSpotNm, setSelectedSpotNm] = React.useState("");
  const [selSpotGuardCnt, setSelSpotGuardCnt] = React.useState();

  const [sortBy, setSortBy] = React.useState("");
  const [Upload, setUpload] = React.useState(false);

  async function handlechangeSearchBySpot(e) {

    setSpotId(e.target.value)
    let idx = e.target.selectedIndex;
    let dataset = e.target.options[idx].dataset;
    // let selectedBuild = dataset.isd;
    setSpotName(dataset.isd);
    setUpload(!Upload)
    RoasterListing(tabName);
  };

  async function handleChangeTabs(tabName) {
    // alert(tabName);
    setTabName(tabName);
    RoasterListing(tabName);
  }

  async function handleChangeSortBy() {
    // alert(sortBy)
    if (sortBy === "")
      setSortBy("ASC")
    else if (sortBy === "DESC")
      setSortBy("ASC")
    else if (sortBy === "ASC")
      setSortBy("DESC")
    setUpload(!Upload);
    RoasterListing(tabName);
  }

  async function RoasterListing(tabName) {
    setShowLoader(true);


    let bodyFormData = {
      listingBy: tabName
    }
    if (sortBy) {
      bodyFormData.sortBy = sortBy;
    }

    if (q) {
      bodyFormData.searchString = q;
    }
    if (spotName) {
      bodyFormData.spotName = spotName;
    }
    if (tabName === 'Today') {
      bodyFormData.startDate = moment().format("YYYY-MM-DD");
    }
    else if (tabName === 'Weekly') {
      bodyFormData.startDate = moment().clone().startOf('week').format("YYYY-MM-DD");
      bodyFormData.endDate = moment().clone().endOf('week').format("YYYY-MM-DD");
    }
    else if (tabName === "Monthly") {
      bodyFormData.startDate = moment().clone().startOf('month').format("YYYY-MM-DD");
      bodyFormData.endDate = moment().clone().endOf('month').format("YYYY-MM-DD");
    }


    await makePostRequest(
      "roaster/getalldutiesbydate/", bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          console.log("Roaster Data");
          console.log(response.data.data.rows);
          const data = response.data.data.rows;
          setDailyRoasterList(data);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);

        swal("There was an error!", "more error details", "warning");
      });
  }

  useEffect(() => {
    GuardsListing();
    SpotListing();
    RoasterListing(tabName);
  }, [q, Upload]);

  async function GuardsListing() {

    let bodyFormData = {
      searchq: q,
      status: 'true',
      sortBy: 'ASC'
    };

    await makePostRequest(
      "guards/guardlisting?searchq=&pageNo=1&count=100&status=true",
      bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          console.log("Guards Response ", response);
          //setlength(response.data.data.rowCount);
          const data = response.data.data.data;
          setGuardsList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function SpotListing() {
    let bodyFormData = {
      sortBy: 'ASC'
    };

    await makePostRequest("spot/getalllist", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          setSpotList(response.data.data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handlechangeGuard = (e) => {
    setSelectedGuard(e.target.value);
  };

  const handlechangeSpot = (e) => {
    setSpotErrMsg("")
    setSelectedSpot(e.target.value);

    let idx = e.target.selectedIndex;
    let dataset = e.target.options[idx].dataset;
    // let selectedBuild = dataset.isd;
    setSelectedSpotNm(dataset.isd);
    setSelSpotGuardCnt(dataset.gcnt);
    // alert("Guard Count"+dataset.gcnt);
  };

  // const handleChangeStartDt = (date) => {
  //   console.log("current date " + moment().format("DD MM YYYY"));
  //   console.log("selected date " + date.format("DD MM YYYY"));

  //   if (date.format("DD MM YYYY") >= moment().format("DD MM YYYY"))
  //   {
  //       setStartDate(date);
  //       setEndDate(date.add(8, "hours"));

  //       if(date.format("DD MM YYYY") == moment().format("DD MM YYYY"))
  //       {
  //         if (date.format("HH") >= moment().format("HH")) {
  //           setStartDate(date);
  //           setEndDate(date.add(8, "hours"));
  //           if (date.format("HH") ==moment().format("HH")) {
  //               if (date.format("mm") >= moment().format("mm")) {
  //                         setStartDate(date);
  //                         setEndDate(date.add(8, "hours"));
  //                 }
  //                 else
  //                 {
  //                   swal(
  //                     "Invalid Time!",
  //                     "Unable to select past time to assign a duty",
  //                     "warning",
  //                     {
  //                       timer: 3000,
  //                       buttons: false,
  //                     }
  //                   ); 
  //                   setStartDate(new Date())
  //                   setEndDate(new Date().add(8, "hours"));
  //                 }
  //           }
  //         }
  //         else{
  //           swal(
  //             "Invalid Time!",
  //             "Unable to select past time to assign a duty",
  //             "warning",
  //             {
  //               timer: 3000,
  //               buttons: false,
  //             }
  //           );
  //           setStartDate(new Date());
  //           setEndDate(new Date().add(8, "hours"));
  //         }
  //       }
  //     } 
  //     else {
  //     swal(
  //       "Invalid Date!",
  //       "Unable to select previous date to assign a duty",
  //       "warning",
  //       {
  //         timer: 3000,
  //         buttons: false,
  //       }
  //     );
  //     setStartDate(new Date())
  //     setEndDate(new Date().add(8, "hours"));
  //   }
  // };

  // const handleChangeEndDt = (date) => {

  //   if (date.format("DD MM YYYY") >= startDate.format("DD MM YYYY")) {
  //     setEndDate(date);
  //     return;
  //   } else {
  //     swal(
  //       "Invalid Date!",
  //       "Unable to select previous date to assign a duty",
  //       "warning"
  //     );
  //     if (date.format("HH") > startDate.format("HH")) {
  //       setEndDate(date);
  //     } else {
  //       swal(
  //         "Invalid Time!",
  //         "End time should be more than start time of duty",
  //         "warning"
  //       );
  //       setEndDate(new Date());
  //     }

  //     if (date.format("mm") > startDate.format("mm")) {
  //       setEndDate(date);
  //     } else {
  //       swal(
  //         "Invalid Time!",
  //         "End time should be more than start time of duty",
  //         "warning"
  //       );
  //       setEndDate(new Date());
  //     }
  //   }
  // };

  const handleChangeStartDt = (date) => {
    setStartDate(date);
    setEndDate(date.add(8, "hours"));
  }

  const handleChangeEndDt = (date) => {
    setEndDate(date);
  }
  // const handleChangeEndDt = (date) => {

  //   if (date.format("DD MM YYYY") >= startDate.format("DD MM YYYY"))
  //   {
  //       setEndDate("");
  //       setEndDate(date);

  //       if(date.format("DD MM YYYY") == startDate.format("DD MM YYYY"))
  //       {
  //         if (date.format("HH") >= startDate.format("HH")) {
  //           setEndDate(date);
  //           if (date.format("HH") ==startDate.format("HH")) {
  //               if (date.format("mm") > startDate.format("mm")) {
  //                         setEndDate(date);
  //                 }
  //                 else
  //                 {
  //                   swal(
  //                     "Invalid Time!",
  //                     "Please select time greater than start time of duty",
  //                     "warning",
  //                     {
  //                       timer: 3000,
  //                       buttons: false,
  //                     }
  //                   ); 
  //                   setEndDate(startDate.add(8, "hours"))
  //                 }
  //           }
  //         }
  //         else{
  //           swal(
  //             "Invalid Time!",
  //             "Unable to select past time to assign a duty",
  //             "warning",
  //             {
  //               timer: 3000,
  //               buttons: false,
  //             }
  //           );
  //           setEndDate(startDate.add(8, "hours"));
  //         }
  //       }
  //     } 
  //     else {
  //     swal(
  //       "Invalid Date!",
  //       "Unable to select previous date to assign a duty",
  //       "warning",
  //       {
  //         timer: 3000,
  //         buttons: false,
  //       }
  //     );
  //     setEndDate(startDate.add(8, "hours"));
  //   }
  // };

  async function handleCancelDuty() {
    setisEditRoaster(false);
    setSelectedGuard("");
    setSelectedSpot("");
    setStartDate(new Date());
    setEndDate(moment().add(8, "hours"));
    setSelectedSpotNm("");
    setSelSpotGuardCnt();
  }

  async function editRoaster(option) {
    console.log("In Edit Roaster ");
    console.log(option);
    setisEditRoaster(true);
    setRoasterId(option.roaster_id);
    setSelectedGuard(option.guard_id);
    setSelectedSpot(option.spot_id);
    setStartDate(option.start_date);
    setEndDate(option.end_date);
  }

  async function addRoaster() {
    setGuardErrMsg("");
    setSpotErrMsg("");
    setStartDtErrMsg("");
    setEndDtErrMsg("");

    // var isEditRoaster = localStorage.getItem("isEditRoaster");

    if (selectedGuard && selectedSpot && startDate && endDate) {
      if (isEditRoaster) {
        setShowLoader(true)
        let inputdata = {
          roaster_id: roasterId,
          guard_id: selectedGuard,
          spot_id: selectedSpot,
          start_date: startDate,
          end_date: endDate,
        };
        await makePostRequest("roaster/update", inputdata)
          .then((response) => {
            // checked codition if responce is empty
            if (response.data.data !== undefined) {
              // localStorage.setItem("roaster", response.data.data.spot_id);
              swal("Success", "Daily Roaster updated successfully", "success", {
                timer: 3000,
                buttons: false,
              });
              localStorage.removeItem("isEditRoaster");
              localStorage.removeItem("roaster_id");

              window.location.reload();
            }
            setShowLoader(false)
          })
          .catch((err) => {
            setShowLoader(false)

            swal("There was an error!", "more error details", "warning");
          });
      } else {
        
        setShowLoader(true)
        let assignedDutiesCnt = 0;
        let inputData = {
          startDate: startDate,
          spotName: selectedSpotNm,
          endDate: endDate
        }

        await makePostRequest("roaster/getalldutiesbydateandspot", inputData)
          .then((response) => {
            if (response.status === 201) {
              console.log(response.data.data);
              if (response.data.data.rowCount > 0) {
                // assignedDutiesCnt = response.data.data.rowCount
                
                let dutiesRes = response.data.data.rows.filter((o) => o.case === "notCompleted");
                console.log(dutiesRes)
                console.log(dutiesRes.length)

                assignedDutiesCnt=dutiesRes.length;
                // new change
                // const assignedDuties = response.data.data.rows;
                // const newDutyStart = new Date(startDate);

              
                // activeDuties = allDuties.filter(duty => {
                //   const dutyStart = new Date(duty.start_date);
                //   const dutyEnd = new Date(duty.end_date);
                //   return dutyStart < newDutyEnd && dutyEnd > newDutyStart;
                // });

                // assignedDutiesCnt = activeDuties.length;
                // console.log("activeDuties count:", assignedDutiesCnt);
                // console.log("selSpotGuardCnt:", selSpotGuardCnt);
              }
              else
                assignedDutiesCnt = 0;
            }

            setShowLoader(false)
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
        // await isDutyAssigned(selectedGuard, startDate, endDate);
        // alert(assignedDutiesCnt+" "+selSpotGuardCnt);
        console.log("assignedDutiesCnt", assignedDutiesCnt)
        console.log("selSpotGuardCnt", selSpotGuardCnt)
        if (assignedDutiesCnt < selSpotGuardCnt) {
          console.log("in if")
          let dutyAssigned = "";
          setShowLoader(true);
          let bodyFormData = {
            guardId: selectedGuard,
            start_date: startDate,
            end_date: endDate,
            // startDate:moment(startDate).format("YYYY-MM-DD"),
            // endDate:moment(endDate).format("YYYY-MM-DD")
          };
          await makePostRequest("guards/isdutyassigned", bodyFormData)
            .then((response) => {
              if (response.status == "201") {
                console.log("Assigned Duty Data ", response);
                if (response.data.data.rowCount > 0) {
                  dutyAssigned = true;
                  const optionSelected = swal("Duty Is already assigned.You are unable to assigned a duty with same date and time interval", "You can update Duty if you want to make any changes in assignment", "warning", {
                    timer: 5000,
                    // dangerMode: true,
                    buttons: false,
                  }
                  );

                  editRoaster(response.data.data.rows[0]);
                } else {
                  dutyAssigned = false;
                }
                // setIsDutyAssigned(false);

                setShowLoader(false);
              } else {
                setShowLoader(false);
                swal("There was an error!", response.message, "warning");
              }
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });

          if (dutyAssigned == false) {
            setShowLoader(true);
            const sDate = new Date(startDate);
            const eDate = new Date(endDate);
            if (eDate > sDate) {

              let inputdata = {
                guard_id: selectedGuard,
                spot_id: selectedSpot,
                start_date: startDate,
                end_date: endDate,
              };
              await makePostRequest("roaster/insert", inputdata)
                .then((response) => {
                  // checked codition if responce is empty
                  if (response.data.data !== undefined) {
                    // localStorage.setItem("spotid", response.data.data.spot_id);
                    swal("Success", "Daily Roaster added successfully", "success", {
                      timer: 1000,
                      buttons: false,
                    });

                    setSelectedGuard("");
                    setSelectedSpot("");
                    setStartDate(new Date());
                    setEndDate(moment().add(8, "hours"));
                    RoasterListing(tabName);
                  }
                  setShowLoader(false);
                })
                .catch((err) => {
                  setShowLoader(false);

                  swal("There was an error!", "more error details", "warning");
                });
            } else {
              swal("Invalid Time!", 'Duty end time should be greater than start time', "warning");
              setShowLoader(false);
            }

          }
        }
        else {
          setSpotErrMsg("No More Duties assign to spot , please change spot name.");
          setShowLoader(false);
        }
      }
    } else {
      if (!selectedGuard) setGuardErrMsg("Required");
      if (!selectedSpot) setSpotErrMsg("Required");
      if (!startDate) setStartDtErrMsg("Required");
      if (!endDate) setEndDtErrMsg("Required");
    }
  }

  // const [dutyAssigned, setIsDutyAssigned] = React.useState(false);

  // async function isDutyAssigned(guardId, startDate, endDate) {
  //   console.log("Start Dtae "+moment(startDate).format("DD-MM-YYYY"))
  //   console.log("Start Time "+moment(startDate).format("hh:mm a"))

  //   let bodyFormData = {
  //     guardId: guardId,
  //     startDate: moment.utc(startDate),
  //     endDate: moment.utc(endDate),
  //     // startDate:moment(startDate).format("YYYY-MM-DD"),
  //     // endDate:moment(endDate).format("YYYY-MM-DD")
  //   };
  //   setShowLoader(true);
  //   makePostRequest("guards/isdutyassigned", bodyFormData)
  //     .then((response) => {
  //       if (response.status == "201") {
  //         console.log("Assigned Duty Data ", response);
  //         if (response.data.data.rowCount > 0)
  //         {
  //           setIsDutyAssigned(true);
  //           swal("Duty Is already assigned.You are unable to assigned a duty with same date and time interval", "You can update Duty if you want to make any changes in assignment", "warning", {
  //             timer: 4000,
  //             buttons: false,
  //           });
  //           editRoaster(response.data.data[0]);

  //         }
  //         else
  //           setIsDutyAssigned(false);

  //           setShowLoader(false);
  //       } else {
  //         setShowLoader(false);
  //         swal("There was an error!", response.message, "warning");
  //       }
  //     })
  //     .catch((err) => {
  //       setShowLoader(false);
  //       swal("There was an error!", "more error details", "warning");
  //     });
  // }

  //Roaster delete
  async function deleteRoaster(roaster_id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete these records? This process cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      await makeGetRequest("roaster/delete/" + roaster_id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            RoasterListing(tabName);
          } else {
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
          console.log(err);
        });
    }
  }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine addDutyPageMain">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/GuardAssignment")}
              />
              Add Duty
            </h1>
            {/* <Button
              className="contentTopLefBt"
              onClick={() => navigate("/AddGuards")}
            >
              Add Guard
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="addSocietyMain">
              <div className="addSocietyInnerMain">
                <div id="successfullAdd">
                  <Grid container spacing={3} className="addCommitee1">
                    <Grid item xs={12} md={6}>
                      <label className="tabsLabel">Select Guard</label>
                      <select
                        className="inputSt"
                        value={selectedGuard}
                        onChange={handlechangeGuard}
                      >
                        <option value="" disabled>
                          Select Guard
                        </option>
                        {guardsList.map((option) => (
                          <option
                            key={option.guard_id}
                            value={option.guard_id}
                            data-isd={option.guard_name}
                          >
                            {option.guard_name}
                          </option>
                        ))}
                      </select>
                      <div className="errorField">{guardErrMsg}</div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label className="tabsLabel">Select Spot</label>
                      <select
                        className="inputSt"
                        value={selectedSpot}
                        onChange={handlechangeSpot}
                      >
                        <option value="" disabled>
                          Select Spot
                        </option>
                        {spotList.map((option) => (
                          <option
                            key={option.spot_id}
                            value={option.spot_id}
                            data-isd={option.spot_name}
                            data-gcnt={option.guard_count}
                          >
                            {option.spot_name}
                          </option>
                        ))}
                      </select>
                      <div className="errorField">{spotErrMsg}</div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label className="tabsLabel">Select Start Date</label>
                      <div className="dateTimeMain">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Stack className="inputSt">
                            <DateTimePicker
                              value={startDate}
                              onChange={(e) => handleChangeStartDt(e)}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              // disabledDate={(current) => {
                              //   return moment().add(-1, "days") >= current;
                              // }}
                              disablePast
                            />
                          </Stack>
                        </LocalizationProvider>
                      </div>
                      <div className="errorField">{startDtErrMsg}</div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label className="tabsLabel">Select End Date</label>
                      <div className="dateTimeMain">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Stack className="inputSt">
                            <DateTimePicker
                              value={endDate}
                              onChange={(e) => handleChangeEndDt(e)}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              disablePast
                            />
                          </Stack>
                        </LocalizationProvider>
                      </div>
                      <div className="errorField">{endDtErrMsg}</div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <div className="modalMainBtMain cancelBtForAllOuter">
                        {isEditRoaster ? (
                          <Button
                            className="modalMainBt cancelBtForAll"
                            onClick={() => handleCancelDuty()}
                          >
                            Cancel
                          </Button>
                        ) : (
                          <></>
                        )}
                        <Button
                          className="modalMainBt"
                          onClick={() => addRoaster()}
                        >
                          {isEditRoaster ? <div>Update</div> : <div>Add</div>}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} className="addCommitee2">
                    <Grid item xs={12} md={12}>
                      <div className="succesMain">
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                        <h4>Success !</h4>
                        <p>
                          Added Duty <br />
                          successfully in database
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className="residentManagementTable GuardAssignmentMain assignDutyTailsMainSpaceTop">
                  <div className="assignDutyTailsMain">
                    <h3 className="assignedDuTx">Assigned Duty</h3>
                    <div className="visitorSearch">
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search"
                          onChangeCapture={(e) => setQ(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" />  */}
                      </div>
                      {/* <div> */}
                      {/* Statics */}
                      {/* <SortIcon
                          className="visitorFilterIco"
                          aria-controls={open10}
                          aria-haspopup="true"
                          aria-expanded={open10}
                          onClick={handleClick10}
                        />
                        <Menu
                          anchorEl={anchorEl10}
                          open={open10}
                          onClose={handleClose10}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem onClick={handleClose10}>
                            Filter Item 1
                          </MenuItem>

                          <MenuItem onClick={handleClose10}>
                            Filter Item 2
                          </MenuItem>
                          <MenuItem onClick={handleClose10}>
                            Filter Item 3
                          </MenuItem>
                        </Menu>
                      </div> */}
                      <div className="sortingIcoOut">
                        {/* Statics */}
                        <ToggleButton
                          value="check"
                          selected={selected}
                          onChange={() => {
                            setSelected(!selected);
                          }}
                        >
                          <ImportExportIcon
                            className="visitorFilterIco"
                            aria-controls={open}
                            aria-haspopup="true"
                            aria-expanded={open}
                            onClick={handleChangeSortBy}
                          />
                        </ToggleButton>
                      </div>
                      <div className="forCurAssiggnDrop">
                        <select className="inputSt" value={spotId} onChange={handlechangeSearchBySpot}>
                          <option value="" >All Spot</option>
                          {spotList.map((option) => (
                            <option key={option.spot_id}
                              value={option.spot_id}
                              data-isd={option.spot_name}
                            >
                              {option.spot_name}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="noticeTabMain assignLisTabOut">
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                          >
                            <Tab label="Today" {...a11yProps(0)} onClick={() => handleChangeTabs('Today')} />
                            <Tab label="Weekly" {...a11yProps(1)} onClick={() => handleChangeTabs('Weekly')} />
                            <Tab label="Monthly" {...a11yProps(2)} onClick={() => handleChangeTabs('Monthly')} />
                            <Tab label="All" {...a11yProps(3)} onClick={() => handleChangeTabs('All')} />
                          </Tabs>
                        </Box>
                        <TabPanel
                          value={value}
                          index={0}
                          className="tabPanelTopSpace"
                        >
                          {dailyRoasterList.length > 0 ?
                            <>
                              {dailyRoasterList.map((option) => (
                                <div className="visitContDiv">
                                  <div className="visitCont1 resideNewContOut">
                                    {/* <div className="textTagDiv">Active</div> */}
                                    <div className="visitContProf">
                                      {option.guard_profile_pic ? (
                                        <img src={option.guard_profile_pic} />
                                      ) : (
                                        <img src={defaultProfilePic} />
                                      )}
                                    </div>
                                    <div className="visitContLeft">
                                      <h3 className="visitContHed">
                                        {option.guard_name}
                                      </h3>
                                      <p className="visitContMob">
                                        {option.contact_no}
                                      </p>
                                      <p className="visitContTime">
                                        {option.email_id}
                                      </p>
                                    </div>
                                    <div className="visitBottCont">
                                      <p>Current Assignment</p>
                                      <b>{option.spot_name}</b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>Start Date</p>
                                      <b>
                                        {moment(option.start_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime">
                                          {moment(option.start_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>End Date</p>
                                      <b>
                                        {moment(option.end_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime endDateDuty">
                                          {moment(option.end_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="resideNewCont">
                                      <CreateIcon
                                        className="editBt"
                                        onClick={() => editRoaster(option)}
                                      // onClick={handleClickOpen("body", option.roaster_id)}
                                      />
                                      <DeleteIcon
                                        className="deleteBt"
                                        onClick={() =>
                                          deleteRoaster(option.roaster_id)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}</>
                            :
                            <>No Duties Assigned For Today</>
                          }
                          {/* // <div className="listPaginationMain">
                          //   <Stack spacing={2}>
                          //     <Pagination
                          //       count={10}
                          //       variant="outlined"
                          //       shape="rounded"
                          //     />
                          //   </Stack>
                          // </div> */}
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={1}
                          className="tabPanelTopSpace"
                        >
                          {dailyRoasterList.length > 0 ?
                            <>
                              {dailyRoasterList.map((option) => (
                                <div className="visitContDiv">
                                  <div className="visitCont1 resideNewContOut">
                                    {/* <div className="textTagDiv">Active</div> */}
                                    <div className="visitContProf">
                                      {option.guard_profile_pic ? (
                                        <img src={option.guard_profile_pic} />
                                      ) : (
                                        <img src={defaultProfilePic} />
                                      )}
                                    </div>
                                    <div className="visitContLeft">
                                      <h3 className="visitContHed">
                                        {option.guard_name}
                                      </h3>
                                      <p className="visitContMob">
                                        {option.contact_no}
                                      </p>
                                      <p className="visitContTime">
                                        {option.email_id}
                                      </p>
                                    </div>
                                    <div className="visitBottCont">
                                      <p>Current Assignment</p>
                                      <b>{option.spot_name}</b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>Start Date</p>
                                      <b>
                                        {moment(option.start_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime">
                                          {moment(option.start_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>End Date</p>
                                      <b>
                                        {moment(option.end_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime endDateDuty">
                                          {moment(option.end_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="resideNewCont">
                                      <CreateIcon
                                        className="editBt"
                                        onClick={() => editRoaster(option)}
                                      // onClick={handleClickOpen("body", option.roaster_id)}
                                      />
                                      <DeleteIcon
                                        className="deleteBt"
                                        onClick={() =>
                                          deleteRoaster(option.roaster_id)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}</>
                            :
                            <>No Duties Assigned For current week</>
                          }
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={2}
                          className="tabPanelTopSpace"
                        >
                          {dailyRoasterList.length > 0 ?
                            <>
                              {dailyRoasterList.map((option) => (
                                <div className="visitContDiv">
                                  <div className="visitCont1 resideNewContOut">
                                    {/* <div className="textTagDiv">Active</div> */}
                                    <div className="visitContProf">
                                      {option.guard_profile_pic ? (
                                        <img src={option.guard_profile_pic} />
                                      ) : (
                                        <img src={defaultProfilePic} />
                                      )}
                                    </div>
                                    <div className="visitContLeft">
                                      <h3 className="visitContHed">
                                        {option.guard_name}
                                      </h3>
                                      <p className="visitContMob">
                                        {option.contact_no}
                                      </p>
                                      <p className="visitContTime">
                                        {option.email_id}
                                      </p>
                                    </div>
                                    <div className="visitBottCont">
                                      <p>Current Assignment</p>
                                      <b>{option.spot_name}</b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>Start Date</p>
                                      <b>
                                        {moment(option.start_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime">
                                          {moment(option.start_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>End Date</p>
                                      <b>
                                        {moment(option.end_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime endDateDuty">
                                          {moment(option.end_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="resideNewCont">
                                      <CreateIcon
                                        className="editBt"
                                        onClick={() => editRoaster(option)}
                                      // onClick={handleClickOpen("body", option.roaster_id)}
                                      />
                                      <DeleteIcon
                                        className="deleteBt"
                                        onClick={() =>
                                          deleteRoaster(option.roaster_id)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}</>
                            :
                            <>No Duties Assigned For current month</>
                          }
                        </TabPanel>

                        <TabPanel
                          value={value}
                          index={3}
                          className="tabPanelTopSpace"
                        >
                          {dailyRoasterList.length > 0 ?
                            <>
                              {dailyRoasterList.map((option) => (
                                <div className="visitContDiv">
                                  <div className="visitCont1 resideNewContOut">
                                    {option.end_date < moment() ?
                                      <div className="textTagDiv">Active</div>
                                      : <></>}
                                    <div className="visitContProf">
                                      {option.guard_profile_pic ? (
                                        <img src={option.guard_profile_pic} />
                                      ) : (
                                        <img src={defaultProfilePic} />
                                      )}
                                    </div>
                                    <div className="visitContLeft">
                                      <h3 className="visitContHed">
                                        {option.guard_name}
                                      </h3>
                                      <p className="visitContMob">
                                        {option.contact_no}
                                      </p>
                                      <p className="visitContTime">
                                        {option.email_id}
                                      </p>
                                    </div>
                                    <div className="visitBottCont">
                                      <p>Current Assignment</p>
                                      <b>{option.spot_name}</b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>Start Date</p>
                                      <b>
                                        {moment(option.start_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime">
                                          {moment(option.start_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="visitBottCont">
                                      <p>End Date</p>
                                      <b>
                                        {moment(option.end_date).format(
                                          "DD-MM-YYYY"
                                        )}{" "}
                                        <em className="assignedDutyTime endDateDuty">
                                          {moment(option.end_date).format(
                                            "hh:mm a"
                                          )}
                                        </em>
                                      </b>
                                    </div>

                                    <div className="resideNewCont">
                                      <CreateIcon
                                        className="editBt"
                                        onClick={() => editRoaster(option)}
                                      // onClick={handleClickOpen("body", option.roaster_id)}
                                      />
                                      <DeleteIcon
                                        className="deleteBt"
                                        onClick={() =>
                                          deleteRoaster(option.roaster_id)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}</>
                            :
                            <>No Duties Assigned </>
                          }
                        </TabPanel>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default AddDutyPage;
